export const parseHeaderPhoto = (headerPhoto) => {
  try {
    return headerPhoto ? JSON.parse(headerPhoto) : {};
  } catch (e) {
    return {};
  }
};
